import { Component, ViewChild } from '@angular/core';
import { MatPaginator } from '@angular/material/paginator';
import { Dashlet } from '../../../../../../app/components/dashlet/component';
import { ApiService } from 'src/app/services/api.service';
import { endpoints } from 'src/app/constants/endpoints';
import { CommonFunctionService } from 'src/app/services/common-function.service';

@Component({
    selector: 'new-users-dashlet',
    templateUrl: 'component.html',
    styleUrls: ['component.scss'],
    standalone: false
})
export class NewUsersDashlet extends Dashlet {
  @ViewChild(MatPaginator) paginator: MatPaginator;

  protected role = 'user-admin';
  protected endpoint = endpoints.user.newUsers;
  public displayedColumns = ['email', 'namex', 'created'];

  constructor(
    protected Api: ApiService,
    protected commonFunctionService: CommonFunctionService
  ) {
    super();
  }
}
